// extracted by mini-css-extract-plugin
export default {"cta":"tF-z","disabled":"uF-z"};